import Avatar from '~/components/avatar/avatar'
import './welcome.css'

function Welcome() {
    return (
        <div>
            <div className="title">
                <Avatar />
            </div>
        </div>
    );
};

export default Welcome;
